'use client';

import { getRubricsQuery } from '@/features/articles';
import { NavLink } from '@/shared/ui';
import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';

import styles from './Header.module.css';

export const Navigation = () => {
  const { data: rubrics } = useQuery(getRubricsQuery());

  return (
    <nav className={clsx(styles.nav, 'scroll')}>
      {rubrics?.map((rubric) => (
        <NavLink href={`/rubric/${rubric.slug}`} key={rubric.id}>
          {rubric.name}
        </NavLink>
      ))}
    </nav>
  );
};
